import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  TableContainer
} from '@material-ui/core';

import { RepeatableContext } from './context';

class RepeatableSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const cols = Object.keys(this.props.getRow({}));
    const fillCol = (rowLength) => {
      let fillLength = cols.length - rowLength;
      return fillLength > 0
        ? Array.from({ length: fillLength }, (v, k) => <TableCell key={k + fillLength}></TableCell>)
        : undefined;
    };

    return (
      <RepeatableContext.Consumer>
        {(context) => (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {cols.map((k) => (
                    <TableCell key={k}>{k}</TableCell>
                  ))}
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {context.data.map((v, i) => (
                  <TableRow key={i} onClick={() => this.props.jumpTo(i)}>
                    {Object.values(this.props.getRow(v)).map((c, i) => (
                      <TableCell key={i}>{c}</TableCell>
                    ))}
                    {fillCol(Object.values(this.props.getRow(v)).length)}
                    <TableCell>
                      {(this.props.canDelete && this.props.canDelete(i)) ||
                      (!this.props.canDelete && i > 0) ? (
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              deleteIndex: i,
                              deleteDialog: true
                            });
                          }}>
                          Delete
                        </Button>
                      ) : (
                        ''
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Dialog
              open={this.state.deleteDialog ? true : false}
              onClose={() => this.setState({ deleteDialog: false })}>
              <DialogTitle>Delete {context.type}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Delete the {context.type} "
                  {context.data[this.state.deleteIndex]
                    ? this.props.getName(context.data[this.state.deleteIndex])
                    : 'Undefined'}
                  "?
                </DialogContentText>
                <DialogActions>
                  <Button onClick={() => this.setState({ deleteDialog: false })}>No</Button>
                  <Button
                    onClick={() =>
                      this.setState({ deleteDialog: false }, () =>
                        context.onDelete(this.state.deleteIndex)
                      )
                    }>
                    Yes
                  </Button>
                </DialogActions>
              </DialogContent>
            </Dialog>
          </TableContainer>
        )}
      </RepeatableContext.Consumer>
    );
  }
}

export default RepeatableSummary;
